import type { FC } from 'react';
import type { SignatureNotNeededProps } from './SignatureNotNeeded.types';
import { Flex, Text } from '@/_components';

export const SignatureNotNeeded: FC<SignatureNotNeededProps> = () => {
  return (
    <Flex>
      <Text type="small">Your signature isn&apos;t required.</Text>
    </Flex>
  );
};
